var style = {"container":"GridContainer-module_container__6KvTN","container-fluid":"GridContainer-module_container-fluid__o6EbU","container-xl":"GridContainer-module_container-xl__26-so","container-lg":"GridContainer-module_container-lg__88muf","container-md":"GridContainer-module_container-md__Ri4-F","container-sm":"GridContainer-module_container-sm__pqrcn"};

export { style as default };
//# sourceMappingURL=GridContainer.module.scss.js.map
